module.exports = __webpack_public_path__ + "img/photo_240750780_2.1df491fc.jpg";